import React from 'react';
import { View, ActivityIndicator, ViewProps, Platform } from 'react-native';
import { styles } from 'styles/components/loading';

export default (): JSX.Element => (
  <View style={styles.container}>
    <View style={styles.indicator}>
      <ActivityIndicator size="large" />
    </View>
  </View>
);

export function Loader({ position = 'center' }: { position?: 'center' | 'top-center' }): JSX.Element {
  const getPositionStyle = (): ViewProps['style'] => {
    switch (position) {
      case 'top-center':
        return {
          position: 'absolute',
          top: 20,
          left: 0,
          right: 0,
          marginHorizontal: 'auto',
        };
      case 'center':
      default:
        return {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          justifyContent: 'center',
          alignItems: 'center',
        };
    }
  };

  if (Platform.OS !== 'web') return <></>;

  return (
    <View style={[{ position: 'absolute', zIndex: 10 }, getPositionStyle()]} pointerEvents="none">
      <ActivityIndicator size="large" />
    </View>
  );
}
